/* component-collection-filter-drawer.js — extracted from snippets/collection-filter-drawer.liquid */
(function () {
    function initFilterDrawer() {
      var drawer = document.querySelector('[data-filter-drawer]');
      if (!drawer || drawer.dataset.bound === 'true') return;
      drawer.dataset.bound = 'true';

      var releaseFocus = null;

      function open() {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('drawer-open');
        if (window.theme) releaseFocus = window.theme.trapFocus(drawer);
      }

      function close() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('drawer-open');
        if (releaseFocus) {
          releaseFocus();
          releaseFocus = null;
        }
      }

      window.openFilterDrawer = open;
      window.closeFilterDrawer = close;

      drawer.querySelectorAll('[data-filter-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      drawer.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.filter-group-item');
          var isOpen = group.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', String(isOpen));
        });
      });

      // Checking a value applies immediately on desktop-width viewports, where
      // the drawer stays open; narrow viewports use the explicit Apply button.
      var form = drawer.querySelector('[data-filter-form]');
      if (form && window.matchMedia('(min-width: 990px)').matches) {
        form.addEventListener('change', function (event) {
          if (event.target.type === 'checkbox') form.submit();
        });
      }
    }

    document.addEventListener('DOMContentLoaded', initFilterDrawer);
    document.addEventListener('shopify:section:load', initFilterDrawer);
    initFilterDrawer();
  })();
